import { render } from "./FetchLeadModel.vue?vue&type=template&id=0f5f9d9c&scoped=true"
import script from "./FetchLeadModel.vue?vue&type=script&lang=js"
export * from "./FetchLeadModel.vue?vue&type=script&lang=js"

import "./FetchLeadModel.vue?vue&type=style&index=0&id=0f5f9d9c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5f9d9c"]])

export default __exports__